/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */
 <template>
  <div>
    <b-form>
      <div class="row">
        <div class="col-md-4">
          <b-form-group label="Produto" label-for>
            <v-select
              class="style-select"
              label="nome"
              :options="produtos"
              :reduce="(item) => item.id_produto"
              v-model="item_produto.id_produto"
            ></v-select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Cultura" label-for>
            <v-select
              class="style-select"
              label="nome_comum"
              :options="culturas"
              :reduce="(item) => item.id_cultura"
              v-model="item_produto.id_cultura"
            ></v-select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Praga" label-for>
            <v-select
              class="style-select"
              label="nome_comum"
              :options="pragas"
              :reduce="(item) => item.id_pragas"
              v-model="item_produto.id_pragas"
            >
              <template #option="item">
                <span>{{ item.nome_comum }} - {{ item.nome_cientifico }}</span>
              </template>
              <template #selected-option="item">
                <span>{{ item.nome_comum }} - {{ item.nome_cientifico }}</span>
              </template>
            </v-select>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group
            id="input-group-1"
            label="Dose mínima:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="item_produto.dose_min"
              type="number"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group
            id="input-group-1"
            label="Dose máxima:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="item_produto.dose_max"
              type="number"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group label="Unidade da dose:" label-for>
            <v-select
              class="style-select"
              label="unid1"
              :options="unidades"
              :reduce="(item) => item.id_unidade"
              v-model="item_produto.id_unidade_aplic"
            ></v-select>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group
            id="input-group-1"
            label="Volume calda (Min):"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="item_produto.volume_calda_min"
              type="number"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group
            id="input-group-1"
            label="Volume calda (Max):"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="item_produto.volume_calda"
              type="number"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group label="Unidade da calda:" label-for>
            <v-select
              class="style-select"
              label="unid1"
              :options="unidades"
              :reduce="(item) => item.id_unidade"
              v-model="item_produto.id_unidade"
            ></v-select>
          </b-form-group>
        </div>
        <div class="col-md-12"></div>
        <div class="col-md-2">
          <b-form-group
            id="input-group-1"
            label="Aplicações mínima:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="item_produto.numero_aplicacoes_min"
              type="number"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group
            id="input-group-1"
            label="Aplicações máxima:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="item_produto.numero_aplicacoes_max"
              type="number"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group
            id="input-group-1"
            label="Intervalo de segurança:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="item_produto.intervalo_seguranca"
              type="number"
              required
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="col-md-2">
          <b-form-group label="Local Aplicação" label-for>
            <v-select
              class="style-select"
              label="nome"
              :options="locais_aplicacao"
              :reduce="(item) => item.id_local_aplicacao"
              v-model="item_produto.id_local_aplicacao"
            ></v-select>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group label="Método de Aplicação" label-for>
            <v-select
              class="style-select"
              label="nome"
              :options="tipos_aplicacao"
              :reduce="(item) => item.id_tipo_aplicacao"
              v-model="item_produto.id_tipo_aplicacao"
            ></v-select>
          </b-form-group>
        </div>
        <div class="col-md-12"></div>
        <div class="col-md-2">
          <b-form-group label="Estágio do Alvo" label-for>
            <v-select
              class="style-select"
              label="descricao"
              :options="epocas_alvo"
              :reduce="(item) => item.id_epoca_alvo"
              v-model="item_produto.id_epoca_praga"
            ></v-select>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group label="Estágio da Cultura" label-for>
            <v-select
              class="style-select"
              label="descricao"
              :options="epocas_alvo"
              :reduce="(item) => item.id_epoca_alvo"
              v-model="item_produto.id_epoca_alvo"
            ></v-select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <h6>
            Estados restritos
            <span
              title="Adicionar restrição"
              class="
                badge
                b-form-tag
                d-inline-flex
                align-items-baseline
                mw-100
                badge-primary
              "
              input-id="tags-pills"
            >
              <button
                aria-keyshortcuts="Delete"
                type="button"
                aria-label="Remove tag"
                class="close b-form-tag-remove"
                @click="showRestricaoEstado"
                >+</button
              >
            </span>
          </h6>
          <div
            v-for="tag in estadosRestritos"
            class="
              badge
              b-form-tag
              d-inline-flex
              align-items-baseline
              mw-100
              badge-primary
            "
            :key="tag"
            style="margin-right: 3px"
          >
            <span
              :title="'Restrito em: ' + tag.nome"
              class="
                badge
                b-form-tag
                d-inline-flex
                align-items-baseline
                mw-100
                badge-primary
              "
              input-id="tags-pills"
            >
              <span class="b-form-tag-content flex-grow-1 text-truncate">{{
                tag.nome
              }}</span>
              <button
                aria-keyshortcuts="Delete"
                type="button"
                aria-label="Remove tag"
                class="close b-form-tag-remove ml-1"
                @click="handleRemoveRestricao(tag.id_estado)"
                >×</button
              >
            </span>
          </div>
        </div>
        <div class="col-md-12"></div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Descrição Dose:"
            label-for="input-1"
          >
            <b-form-textarea
              id="input-1"
              v-model="item_produto.desc_dose"
              required
              no-resize
              rows="5"
              max-rows="5"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Descrição modo de aplicação:"
            label-for="input-1"
          >
            <b-form-textarea
              id="input-1"
              v-model="item_produto.desc_modo_aplicacao"
              required
              no-resize
              rows="5"
              max-rows="5"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Descrição volume calda:"
            label-for="input-1"
          >
            <b-form-textarea
              id="input-1"
              v-model="item_produto.desc_volume_calda"
              required
              no-resize
              rows="5"
              max-rows="5"
            ></b-form-textarea>
          </b-form-group>
        </div>

        <div class="col-md-4 mb-4">
          <b-form-checkbox v-model="item_produto.ativo" type="text" required
            >Ativo</b-form-checkbox
          >
        </div>
      </div>
      <b-button
        type="submit"
        variant="success"
        @click.prevent="salvar"
        >Salvar</b-button
      >
    </b-form>
    <b-modal
      id="modal-term"
      title="Tempo de Responsabilidade"
      title-class="font-18"
    >
      <p
        >Declaro que as informações inseridas relacionadas ao Receituário
        Agronômico estão corretas</p
      >
      <b-form-group
        id="input-group-1"
        label="Insira o número do seu CREA: "
        label-for="input-1"
      >
        <b-form-input
          id="input-1"
          v-model="item_produto.termo_responsabilidade"
          type="text"
          required
        ></b-form-input>
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="salvar">Sim</b-button>
      </template>
    </b-modal>
    <b-modal
      v-model="modalExcluirRestricao"
      title="Aviso"
      title-class="font-18"
    >
      <p>Tem certeza que deseja excluir a restrição para este estado?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="show = false">Não</b-button>
        <b-button variant="danger" @click="removeRestricaoEstado()"
          >Sim</b-button
        >
      </template>
    </b-modal>
    <b-modal
      v-model="modalEstados"
      title="Lista de estados"
      title-class="font-18"
    >
      <b-form-group label="Estado" label-for>
        <b-form-group>
          <b-form-checkbox-group
            id="checkbox-group"
            v-model="estadosRestritos"
            stacked
          >
            <b-form-checkbox
              v-for="(estado, index) in estados"
              :value="estado"
              :key="index"
              >{{ estado.nome }}</b-form-checkbox
            >
          </b-form-checkbox-group>
        </b-form-group>
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="modalEstados = false">Não</b-button>
        <b-button variant="danger" @click="addRestricaoEstado">Sim</b-button>
      </template>
    </b-modal>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </div>
</template>
<script>
import Service from '@src/services/itens_produto'
import { mask } from 'vue-the-mask'
import Loading from 'vue-loading-overlay'

import LocalAplicacao from '@src/services/local_aplicacao'
import Praga from '@src/services/pragas'
import Produto from '@src/services/produto'
import TipoAplicacao from '@src/services/tipo-aplicacao'
import Unidade from '@src/services/unidade'
import Cultura from '@src/services/culturas'
import EpocaALvo from '@src/services/epoca-alvo'
import estado from '@/src/services/estados-register'
import RestricoesEstado from '@src/services/restricoes-estado'

const moment = require('moment')
moment.locale('pt-br')

export default {
  components: {
    Loading,
  },
  directives: { mask },
  props: {
    item_produto: {},
  },
  data() {
    return {
      culturas: [],
      epocas_alvo: [],
      locais_aplicacao: [],
      pragas: [],
      produtos: [],
      tipos_aplicaco: [],
      unidades: [],
      estados: [],
      estadosRestritos: [],
      estadosRestritosSalvos: [],
      modal: {
        show: false,
        mensagems: null,
        sucesso: null,
      },
      isLoading: false,
      modalEstados: false,
      selectedState: '',
      idEstado: '',
      idRestricaoEstado: '',
      modalExcluirRestricao: false,
    }
  },
  created() {
    if (this.item_produto.id_item_produto) {
      this.findRestricoes()
    }
  },
  mounted() {
    this.item_produto.ativo = this.item_produto.ativo ? true : false
    this.handleGet()
  },

  methods: {
    findRestricoes() {
      this.isLoading = this.loading(this.isLoading)
      const token = this.$store.state.auth.currentUser.token
      RestricoesEstado.listarPorRestricao(
        token,
        this.item_produto.id_item_produto
      ).then((resposta) => {
        let count = 0
        if (resposta.data.dados.length === 0) {
          this.isLoading = this.loading(this.isLoading)
        } else {
          this.estadosRestritosSalvos = resposta.data.dados
          this.estadosRestritos = []
          console.log(this.estadosRestritosSalvos)
          this.estadosRestritosSalvos.map((restricao) => {
            count++
            this.estadosRestritos.push(restricao.id_estado)
            if (count >= resposta.data.dados.length) {
              this.isLoading = this.loading(this.isLoading)
            }
          })
        }
      })
    },
    loading(a) {
      a = !this.isLoading
      return a
    },
    modalShow() {
      if (this.modal.show === true) {
        this.modal.show = false
      }
    },
    showRestricaoEstado() {
      this.selectedState = ''
      this.modalEstados = true
    },
    addRestricaoEstado() {
      this.modalEstados = false
    },
    handleRemoveRestricao(id) {
      this.modalExcluirRestricao = true
      this.idEstado = id
    },
    removeRestricaoEstado() {
      const token = this.$store.state.auth.currentUser.token
      let restricaoEstado =
        this.estadosRestritosSalvos[
          this.estadosRestritosSalvos.findIndex(
            (i) => i.id_estado.id_estado === this.idEstado
          )
        ]
      if (restricaoEstado) {
        this.isLoading = this.loading(this.isLoading)
        RestricoesEstado.deletar(token, restricaoEstado.id_restricao_estado)
          .then((resposta) => {
            this.estadosRestritos.splice(
              this.estadosRestritos.findIndex(
                (i) => i.id_estado === this.idEstado
              ),
              1
            )
            this.modalExcluirRestricao = false
            this.isLoading = this.loading(this.isLoading)
          })
          .catch((err) => {
            this.isLoading = this.loading(this.isLoading)
            this.$bvToast.toast(
              'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
            this.modalExcluirRestricao = false
          })
      } else {
        this.estadosRestritos.splice(
          this.estadosRestritos.findIndex((i) => i.id_estado === this.idEstado),
          1
        )
        this.modalExcluirRestricao = false
      }
    },
    salvar() {
      this.$bvModal.hide('modal-term')
      const token = this.$store.state.auth.currentUser.token
      this.item_produto.restricoes_estado = this.estadosRestritos
      if (this.item_produto.id_item_produto) {
        this.isLoading = this.loading(this.isLoading)
        Service.update(token, this.item_produto)
          .then((resposta) => {
            this.isLoading = this.loading(this.isLoading)
            this.$bvToast.toast('Atualizado com sucesso', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.modal.mensagems = resposta.data.aviso
          })
          .catch((erro) => {
            this.$bvToast.toast(erro.response.data.data.join(', '), {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = this.loading(this.isLoading)
          })
      } else {
        this.isLoading = this.loading(this.isLoading)
        Service.salvar(token, this.item_produto)
          .then((resposta) => {
            if (!resposta.data.sucesso) {
              this.$bvToast.toast(resposta.data.mensagem, {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            } else {
              this.$bvToast.toast('Salvo com sucesso!', {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            }
            this.item_produto = {}
            this.estadosRestritos = []
            this.isLoading = this.loading(this.isLoading)
          })
          .catch((erro) => {
            console.log(erro)
            this.isLoading = this.loading(this.isLoading)
            this.$bvToast.toast(
              erro.response ? erro.response.data.data : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
          })
      }
    },
    async handleGet() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      const responseLocalAplicacao = await LocalAplicacao.listar(token)
      this.locais_aplicacao = responseLocalAplicacao.data.dados

      const responsePragas = await Praga.listar(token)
      this.pragas = responsePragas.data.dados

      const responseProduto = await Produto.listar(token)
      this.produtos = responseProduto.data.dados

      const responseTipoAplicacao = await TipoAplicacao.listar(token)
      this.tipos_aplicacao = responseTipoAplicacao.data.dados

      const responseUnidade = await Unidade.listar(token)
      this.unidades = responseUnidade.data.dados

      const responseCultura = await Cultura.listar(token)
      this.culturas = responseCultura.data.dados

      const responseEpocaALvo = await EpocaALvo.listar(token)
      this.epocas_alvo = responseEpocaALvo.data.dados

      const responseEstado = await estado.listar(token)
      this.estados = responseEstado.data.dados

      this.isLoading = this.loading(this.isLoading)
    },
  },
}
</script>

<style>
</style>